<template>
  <el-dialog title="" :visible.sync="formVisible">
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="重置密码" name="first">
        <el-form :model="forgetForm" class="reg">
          <el-form-item>
            <el-input v-model="forgetForm.phone" placeholder="请输入手机号" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item>
            <el-input v-model="forgetForm.password" placeholder="请输入6-16位字符的密码" type="password" autocomplete="off"></el-input>
          </el-form-item>
          <div class="yzm">
            <div>
              <el-input v-model="forgetForm.code" placeholder="请输入短信验证码" autocomplete="off"></el-input>
            </div>
            <div>
              <button type="button" class="txt btn cursorPointer" @click="getYzm">{{codeText}}</button>
            </div>
          </div>
        </el-form>
        <div class="register">
          <el-button type="primary" :disabled="btnRegState===false" :class="{btnBg:btnRegState}" @click="updatePwd">确定</el-button>
        </div>

      </el-tab-pane>
    </el-tabs>
    <div slot="footer" class="dialog-footer">

    </div>
  </el-dialog>
</template>

<script>
import { upPwd, Code} from "@/api/user";
export default {
  name: "ForgetPwd",
  data() {
    return{
      codeText: '获取验证码',
      activeName: 'first',
      formVisible: false,
      forgetForm: {
        phone: '',
        password: '',
        code: '',
      },
    }
  },
  mounted() {
    window.addEventListener('keydown',this.keyDown);
  },
  computed :{
    btnRegState(){//当用户名和密码框都不为空时btnRegState==true,利用这个计算属性来动态控制按钮的禁用和颜色
      return this.forgetForm.password !=="" && this.forgetForm.phone !=="" && this.forgetForm.code !==""
    }
  },
  destroyed(){
    window.removeEventListener('keydown',this.keyDown,false);
  },
  methods: {
    init(data){
      this.formVisible=true;
      //data是父组件弹窗传递过来的值，我们可以打印看看
      // console.log(data);
    },
    handleClick(tab, event) {
      // console.log(tab, event);
    },
    keyDown(e){
      //如果是回车则执行登录方法
      if(e.keyCode === 13){
        //需要执行的登录方法
        this.toLogin();
      }
    },
    updatePwd(){
      let data = {
        phone: this.forgetForm.phone,
        code: this.forgetForm.code,
        password: this.forgetForm.password,
      }
      upPwd( data ).then((response) => {
        console.log(response);
        if (response.code === 2000) {
          this.formVisible = false;
          this.$message.success({message:'密码修改成功',duration:1000,offset:400})
        }
      });
    },
    getYzm(){
      Code(  {phone: this.forgetForm.phone}  ).then(( response ) => {
        this.timer();
        // console.log( response );
      });
    },
    timer() {//验证码倒计时
      let num = 60;
      let that = this;
      that.codeText = num + "秒后重新发送";
      let time = setInterval(function() {
        if(num == 0) {
          clearInterval(time);
          time = null;
          that.codeText = "重发验证码";
        } else {
          num--;
          that.codeText = num + "秒后重新发送";
        }

      }, 1000);
    },

  }
}
</script>

<style scoped>
>>>.register .el-button{
  width: 100%;
}

>>>.register .el-button--primary {
  background-color: #87b5f9;
  border-color: #87b5f9;
}

>>>.el-tabs__nav-wrap::after{
  background-color: transparent;
}

>>>.el-dialog__body{
  display: flex;
  margin: 0 0 30px 60px;
}

>>>.el-tabs__item{
  padding: 0 100px;
}

.yzm{
  display: flex;
  gap: 10px;
}

.btn {
  border: 1px solid #c9c9c9;
  background-color: #fff;
  color: #555;
  letter-spacing: 2px;
  height: 40px;
  padding: 0 15px;
  border-radius: 3px;
}

.cursorPointer {
  cursor: pointer;
}

>>>.reg .el-form-item {
  margin-bottom: 10px;
}

>>>.btnBg {
  background-color: rgb(0, 22, 70)!important;
  border-color: rgb(0, 22, 70)!important;
}
</style>



// WEBPACK FOOTER //
// src/components/common/ForgetPwd.vue